import Http from "../util/Http";

const API_URL = process.env.VUE_APP_API_URL

export const fileUpload = (data) => {
  return Http.post(`${API_URL}/files`, data)
}
